module.exports = __webpack_public_path__ + "dc154837f1500023992e858f717359a1.svg";